module.exports.getStyleString = (styleObj) => {
  let s = '';
  const keys = Object.keys(styleObj);
  keys.forEach((key) => {
    const value = styleObj[key];
    const dashKey = key.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);
    s += `${dashKey}: ${value}; `;
  });
  return s;
}

module.exports.returnStringIfExists = (string, item) =>{
  if (!item) return '';
  return string;
}
